import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "datatable",
  "use": "datatable-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"datatable\"><g fill=\"currentColor\"><path d=\"M8 5.6c-3.34 0-5.753-.674-7.2-1.625V5.6C.8 6.215 2.573 8 8 8s7.2-1.785 7.2-2.4V3.975C13.753 4.926 11.34 5.6 8 5.6z\" /><path d=\"M8 12c5.427 0 7.2-1.785 7.2-2.4V7.975C13.753 8.926 11.34 9.6 8 9.6S2.247 8.926.8 7.975V9.6C.8 10.215 2.573 12 8 12zm0-8c4.156 0 6.164-1.045 6.879-1.812C13.923.748 10.95 0 8 0S2.077.748 1.121 2.188C1.836 2.955 3.844 4 8 4z\" /><path d=\"M8 13.6c-3.34 0-5.753-.674-7.2-1.625v.825C.8 14.901 4.422 16 8 16s7.2-1.099 7.2-3.2v-.825c-1.447.951-3.86 1.625-7.2 1.625z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/datatable.svg
// module id = ftAf
// module chunks = 38 43